import { render, staticRenderFns } from "./PrintOddsPage.vue?vue&type=template&id=8f584d44"
import script from "./PrintOddsPage.vue?vue&type=script&lang=js"
export * from "./PrintOddsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports